import React from 'react';

export default function Spinner() {
  return (
    <div>
        <div className="spinner"></div>
    </div>
  )
}
